import React, { useState } from "react";
function WithLoader(WrappedComponent) {
  return function EnhancedComponent(props) {
    const [isLoaderShown, setIsLoaderShown] = useState(false);
    return <WrappedComponent {...props} isLoaderShown={isLoaderShown} setIsLoaderShown={setIsLoaderShown} />;
  };
}
export default WithLoader;
